import { Kilograms } from '../../Weight';

export const getChartData = (metrics, activeTab) => {
  return [
    ['Time', 'Percent', { type: 'string', role: 'tooltip', p: { html: true } }],
    ...metrics[activeTab].chart.map((item) => [
      item[0],
      item[2],
      `<div class="chart-tooltip"><span>${item[0]}</span>${`<div>Weight: <b>${item[2]} (${Math.round(
        item[1]
      )} %)</b></div>`}</div>`,
    ]),
  ];
};

export const createRows = (rows) => {
  return rows.map((item, index) => ({
    id: index,
    cells: [
      {
        label: item[0],
      },
      {
        label: `${item[1]}`,
      },
      {
        label: <Kilograms quantity={item[2]} />,
      },
    ],
    minHeight: '42px',
  }));
};

export const createTotalRows = rows => {
  return [rows[0], rows[1], { Component: <Kilograms quantity={rows[2].label} /> }];
};
